import styled, { css } from 'styled-components';
import { getSizeFromProps, getAlignmentFromProps, getPrimaryColorFromProps, getSrcFromProps } from './utils/getStyleFromProps.js';

var svgStyles = css(["width:", ";height:", ";max-height:100%;max-width:100%;overflow:hidden;pointer-events:none;vertical-align:", ";"], getSizeFromProps, getSizeFromProps, getAlignmentFromProps);
var IconWrapper = styled.span.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-15os4vo-0"
})(["display:inline-block;width:", ";height:", ";color:", ";fill:currentColor;flex-shrink:0;line-height:1;> svg{", "}"], getSizeFromProps, getSizeFromProps, getPrimaryColorFromProps, svgStyles);
var MaskIcon = styled.span.withConfig({
  displayName: "MaskIcon",
  componentId: "sc-15os4vo-1"
})(["", ";display:inline-block;mask:url(", ") center center/100% 100% no-repeat;background-color:currentColor;"], svgStyles, getSrcFromProps);

export { IconWrapper, MaskIcon };
